import { useQuery } from "@apollo/client";
import {
  AssortmentValidationRequirementsFragment,
  OrderValidationRequirementsDoc,
  WorkspaceValidationRequirementsDoc,
} from "operations";
import { HeaderPageView } from "../WorkspaceOrderHeader";

export const useHasWorkspaceValidationRequirements = (
  workspaceId: string,
  assortmentId: string,
  view: HeaderPageView
) => {
  const isValid = (data: AssortmentValidationRequirementsFragment) => {
    return (
      data.attributeValidationRequirements.length > 0 ||
      data.validationRequirements.length > 0
    );
  };
  const workspaceData = useQuery(WorkspaceValidationRequirementsDoc, {
    variables: { workspaceId },
    skip: view !== "workspace",
  });
  const orderData = useQuery(OrderValidationRequirementsDoc, {
    variables: { assortmentId },
    skip: view !== "order",
  });

  if (view === "order") {
    return (
      !orderData.loading &&
      orderData.data?.assortment &&
      isValid(orderData.data.assortment)
    );
  }

  return (
    !workspaceData.loading &&
    workspaceData.data?.retailWorkspace?.assortments?.find((assortment) =>
      isValid(assortment)
    ) !== undefined
  );
};
